import React, { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import ProfileContactInfo from "./ProfileContactInfo";

const ProfileContactInfoTopRight = ({ language }) => {
  const { documentLayout } = useContext(ResourceContext);

  if (documentLayout && documentLayout.infoBoxPlacement !== "RIGHT") {
    return null;
  }
  return <ProfileContactInfo language={language} />;
};

export default ProfileContactInfoTopRight;
